'use strict';

function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.waitForTarget = exports.Variable = undefined;
var _findLastIndex2 = require('lodash/findLastIndex');
var _findLastIndex3 = _interopRequireDefault(_findLastIndex2);
var _findIndex2 = require('lodash/findIndex');
var _findIndex3 = _interopRequireDefault(_findIndex2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _isObject2 = require('lodash/isObject');
var _isObject3 = _interopRequireDefault(_isObject2);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}(); // vim: set et sw=2 ts=2 sts=2 ff=unix fenc=utf8:
// Author: Kuan Huang<kuan.huang@import.io>
// Created on 2016-11-30

/**
 * Wait for target element appear
 */
var waitForTarget = exports.waitForTarget = function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(target) {
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var targetCheckInterval = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;
    var base = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
    var startTime, trueTarget;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            startTime = new Date();
          case 1:
            if (!(Date.now() - startTime < timeout)) {
              _context.next = 11;
              break;
            }
            trueTarget = deserializeElement(target, base);
            if (!trueTarget) {
              _context.next = 7;
              break;
            }
            return _context.abrupt('return', trueTarget);
          case 7:
            _context.next = 9;
            return new Promise(function (r) {
              return setTimeout(r, targetCheckInterval);
            });
          case 9:
            _context.next = 1;
            break;
          case 11:
            throw new Error('cannot find target ' + target.cssSelector + ' after ' + timeout + 'ms');
          case 12:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, this);
  }));
  return function waitForTarget(_x4) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * resolve variables value from input
 * @param {Action|JSON} object the action
 * @param {object} input input dict
 * @return json object of the action
 */

exports.serializeEvent = serializeEvent;
exports.deserializeEvent = deserializeEvent;
exports.serializeElement = serializeElement;
exports.deserializeElement = deserializeElement;
exports.resolveVariables = resolveVariables;
exports.findNearestElement = findNearestElement;
var _object = require('object.pick');
var _object2 = _interopRequireDefault(_object);
var _webExtractor = require('@import/web-extractor');
var _actions = require('./actions.js');
var _actions2 = _interopRequireDefault(_actions);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
function _toConsumableArray(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }
    return arr2;
  } else {
    return Array.from(arr);
  }
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
var EventInit = function () {
  function EventInit() {
    _classCallCheck(this, EventInit);
  }
  _createClass(EventInit, null, [{
    key: 'Event',
    get: function get() {
      return {
        bubbles: false,
        cancelable: false
        //scoped: false,
        //composed: false,
      };
    }
  }, {
    key: 'UIEvent',
    get: function get() {
      return Object.assign(this.Event, {
        detail: 0
        //view: null,
      });
    }
  }, {
    key: 'FocusEvent',
    get: function get() {
      return this.UIEvent;
    }
  }, {
    key: 'MouseEvent',
    get: function get() {
      return Object.assign(this.UIEvent, {
        screenX: 0,
        screenY: 0,
        clientX: 0,
        clientY: 0,
        ctrlKey: false,
        shiftKey: false,
        altKey: false,
        metaKey: false,
        button: 0,
        buttons: 0,
        relatedTarget: null
      });
    }
  }, {
    key: 'KeyboardEvent',
    get: function get() {
      return Object.assign(this.UIEvent, {
        key: '',
        code: '',
        location: 0,
        ctrlKey: false,
        shiftKey: false,
        altKey: false,
        metaKey: false,
        repeat: false,
        //isComposing: false,
        charCode: 0,
        keyCode: 0,
        which: 0
      });
    }
  }]);
  return EventInit;
}();
EventInit.displayName = 'EventInit';
function serializeEvent(event) {
  if (!EventInit[event.constructor.name]) throw Error('not supported event type: ' + event.constructor.name);
  var eventInit = (0, _object2.default)(event, Object.keys(EventInit[event.constructor.name]));
  for (var key in eventInit) {
    if (eventInit[key] && eventInit[key].nodeName) {
      eventInit[key] = serializeElement(eventInit[key]);
    }
  }
  return {
    constructor: event.constructor.name,
    target: serializeElement(event.target),
    typeArg: event.type,
    eventInit: eventInit
  };
}
function deserializeEvent(event) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (!EventInit[event.constructor]) throw Error('not supported event type: ' + event.constructor);
  var eventInit = Object.assign({}, event.eventInit);
  for (var key in eventInit) {
    eventInit[key] = deserializeElement(eventInit[key], base);
  }
  return new base.defaultView[event.constructor](event.typeArg, eventInit);
}
function serializeElement(element) {
  return _serializeElement_webExtractor(element);
}
function _serializeElement_webExtractor(element) {
  var cssSelector = void 0;
  if (element && element.nodeName && element.nodeType != Node.DOCUMENT_NODE) {
    // web-extractor will cache the attributes for an element
    // adding this hack to clear the cache
    if (element.__path) {
      element.__path = undefined;
    }
    var elementSelector = (0, _webExtractor.getElementSelector)(element, getRootNode(element), false);
    if (elementSelector) cssSelector = (0, _webExtractor.toCssSelector)(elementSelector);
  }
  var label = void 0;
  if (element.tagName === 'INPUT' && element.labels && element.labels.length) {
    label = [].concat(_toConsumableArray(element.labels)).map(function (l) {
      return (l.innerText || '').trim();
    }).filter(function (x) {
      return x;
    })[0];
  }
  if (element.tagName === 'INPUT' && !label) {
    var prevElement = element.previousSibling || element.offsetParent;
    while (prevElement) {
      if (prevElement.nodeType === Node.TEXT_NODE && prevElement.textContent.trim()) {
        label = prevElement.textContent.trim();
        break;
      } else if (prevElement.innerText) {
        label = prevElement.innerText;
        break;
      }
      prevElement = prevElement.previousSibling || prevElement.offsetParent;
    }
  }
  if (label && label.length > 100) {
    label = undefined;
  }
  return {
    cssSelector: cssSelector || null,
    type: element.type,
    name: element.name,
    label: label
  };
}
function deserializeElement(element) {
  var base = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;
  if (element && element.cssSelector !== undefined) {
    if (!element.cssSelector) return base;
    return base.querySelector(element.cssSelector);
  }
  return element;
}
function getRootNode(node) {
  if (node.parentNode != null) {
    return getRootNode(node.parentNode);
  }
  return node;
}

/**
 * Mark variables in actions, accept input to change the variables used in actions
 *
 * @param {Boolean} variable=false mark as variable
 * @param {String} name name of variable
 * @param {ANY} defaultValue default value of variable
 */

var Variable = exports.Variable = function () {
  _createClass(Variable, [{
    key: 'variable',
    get: function get() {
      return this['$variable$'];
    },
    set: function set(value) {
      return this['$variable$'] = value;
    }
  }]);
  function Variable() {
    var variable = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var name = arguments[1];
    var defaultValue = arguments[2];
    _classCallCheck(this, Variable);
    this.variable = variable;
    this.name = name;
    this.defaultValue = defaultValue;
  }
  _createClass(Variable, [{
    key: 'toJSON',
    value: function toJSON() {
      if (this.variable && this.name) {
        return {
          '$variable$': this.variable,
          name: this.name,
          defaultValue: this.defaultValue
        };
      } else {
        return this.defaultValue;
      }
    }

    /**
     * get variable value
     * if it's a variable, try to pick up the value from obj.input, otherwise return defaultValue
     * @param {Action} obj instance of the variable
     * @return {ANY} value
     */
  }, {
    key: 'get',
    value: function get(obj) {
      if (this.variable && obj.input && this.name) {
        return (0, _get3.default)(obj.input, this.name, this.defaultValue);
      } else {
        return this.defaultValue;
      }
    }

    /**
     * set variable value
     * @param {Action} obj instance of the variable
     * @param {ANY} value value of variable
     */
  }, {
    key: 'set',
    value: function set(obj, value) {
      if (value && (value['$variable$'] || value instanceof Variable)) {
        this.variable = value['$variable$'];
        this.name = value.name;
        this.defaultValue = value.defaultValue;
      } else {
        this.defaultValue = value;
      }
    }
  }]);
  return Variable;
}();
Variable.displayName = 'Variable';
function resolveVariables(object) {
  var input = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (object instanceof _actions2.default) {
    object = object.toJSON();
  }
  if ((0, _isObject3.default)(object) && object['$variable$']) {
    return (0, _get3.default)(input, object.name, object.defaultValue);
  } else if ((0, _isObject3.default)(object)) {
    for (var key in object) {
      object[key] = resolveVariables(object[key], input);
    }
  }
  return object;
}
function findNearestElement(element, cssSelector) {
  var elem = element;
  while (elem && !elem.querySelector(cssSelector)) {
    elem = elem.parentElement;
  }
  if (!elem) return;
  var matchedElements = new Set(elem.querySelectorAll(cssSelector));
  var elementList = [].concat(_toConsumableArray(elem.getElementsByTagName('*')));
  var targetIndex = elementList.indexOf(element);
  var preceding = elementList.slice(0, targetIndex);
  var precedingElemIndex = (0, _findLastIndex3.default)(preceding, function (e) {
    return matchedElements.has(e);
  });
  var following = elementList.slice(targetIndex + 1);
  var followingElemIndex = (0, _findIndex3.default)(following, function (e) {
    return matchedElements.has(e);
  });
  if (precedingElemIndex == -1) {
    return following[followingElemIndex];
  } else if (followingElemIndex == -1) {
    return preceding[precedingElemIndex];
  } else if (preceding.length - precedingElemIndex < followingElemIndex) {
    return preceding[precedingElemIndex];
  } else {
    return following[followingElemIndex];
  }
}